import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { GuardsModule } from "./guards/guards.module";
import { PipesModule } from "./pipes/pipes.module";
import { ServicesModule } from "./services/services.module";

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    GuardsModule,
    HttpModule,
    PipesModule,
    ReactiveFormsModule,
    RouterModule,
    ServicesModule
  ],
  exports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    GuardsModule,
    HttpModule,
    PipesModule,
    ReactiveFormsModule,
    RouterModule,
    ServicesModule
  ]
})
export class AppCommonModule {}



// WEBPACK FOOTER //
// ./src/app/common/app-common.module.ts